import React, { useEffect, useState, useContext } from "react";
import StoreContext from "contexts/StoreContext";
import { apiService } from "service/ApiService";
import { Button, Table } from "react-bootstrap";
import DayClosureSummariesModal from "components/Modals/DayClosureSummariesModal";
import DateRangeContext from "contexts/DateRangeContext";
import { serverTimesampToNormalDate } from "utils/AppUtils";
import AadeZModal from "components/Modals/AadeZModal";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

export default function SalesPerDayClosureTable() {
  const {
    t,
  } = useTranslation();

  const { storeId, setStoreId } = useContext(StoreContext);
  const { dateRange, setDateRange } = useContext(DateRangeContext);
  const [data, setData] = useState([]);
  const [totalSum, setTotalSum] = useState(0);
  const [totalDocs, setTotalDocs] = useState(0);
  const [totalDiff, setTotalDiff] = useState(0);
  const [totalPercentage, setTotalPercent] = useState(0);
  let [openModal, setOpenModal] = useState(0);
  let [openAadeModal, setOpenAadeModal] = useState(0);
  const [dayClosureId, setDayClosureId] = useState(null);
  const [showLoader, setShowLoader] = useState(true);

  const showModal = (dayClosureId) => {
    setDayClosureId(dayClosureId);
    setOpenModal(++openModal);
  };

  const showAadeModal = (dayClosureId) => {
    setDayClosureId(dayClosureId);
    setOpenAadeModal(++openAadeModal);
  };

  const closeModal = () => setOpenModal(0);
  const closeAadeModal = () => setOpenAadeModal(0);

  const fetchData = async () => {
    setShowLoader(true);
    try {
      if (!storeId) return;
      const dataResponse = await apiService.post(`api/v1/stores/${storeId}/sales-per-day-closure`, {
        fromDate: dateRange[0],
        toDate: dateRange[1],
      });
      setData(dataResponse);
      const totalSum = dataResponse.reduce((acc, row) => acc + parseFloat(row.total), 0);
      const totalDocuments = dataResponse.reduce((acc, row) => acc + parseFloat(row.documents), 0);
      const totalDifference = totalSum - totalDocuments;
      const totalPercentage = (totalDocuments / totalSum) * 100;
      setTotalSum(totalSum);
      setTotalDocs(totalDocuments);
      setTotalDiff(totalDifference);
      setTotalPercent(totalPercentage);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalSum(0);
      setTotalDiff(0);
      setTotalPercent(0);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [storeId, dateRange]);

  return (
    <>
      {showLoader ? (
        <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
          <ClipLoader size={50} color={"#ff6fbc"} />
        </div>
      ) : data.length !== 0 ? (
        <>
          <DayClosureSummariesModal dayClosureId={dayClosureId} openModal={openModal} closeModal={closeModal} />
          <AadeZModal dayClosureId={dayClosureId} openModal={openAadeModal} closeModal={closeAadeModal} />
          <Table className="table-hover" style={{ tableLayout: "fixed" }}>
            <thead>
              <tr>
                <th className="align-text-left">{t("tables.headers.dateAbbreviated")}</th>
                <th className="align-text-right">{t("tables.headers.sales")}</th>
                <th className="align-text-right">{t("tables.headers.docs")}</th>
                <th className="align-text-right">{t("tables.headers.diff")}</th>
                <th className="align-text-right">%</th>
                <th className="align-text-right"></th>
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <tr key={row.id}>
                  <td className="align-text-left" style={{ cursor: "pointer" }}>
                    <Button onClick={() => showModal(row.day_closure_local_id)} size="sm" className="btn-outline" title={t("common.labels.viewClosure")}>
                      {serverTimesampToNormalDate(row.date, "DD/MM/YY")}
                    </Button>
                  </td>
                  <td className="align-text-right">{row.total.toFixed(2)}</td>
                  <td className="align-text-right">{row.documents.toFixed(2)}</td>
                  <td className="align-text-right">{row.difference.toFixed(2)}</td>
                  <td className="align-text-right">{row.percentage.toFixed(0)}</td>
                  <td className="align-text-right" style={{ cursor: "pointer" }}>
                    <Button
                      onClick={() => showAadeModal(row.day_closure_local_id)}
                      size="sm"
                      variant="danger"
                      className="btn-outline"
                      title={t("common.labels.viewZReport")}
                    >
                      Z
                    </Button>
                  </td>
                </tr>
              ))}
              <tr key="total">
                <td className="bold align-text-left">{t("tables.headers.totalAbbreviated")}</td>
                <td className="bold align-text-right">{totalSum.toFixed(2)}</td>
                <td className="bold align-text-right">{totalDocs.toFixed(2)}</td>
                <td className="bold align-text-right">{totalDiff.toFixed(2)}</td>
                <td className="bold align-text-right">{totalPercentage.toFixed(0)}</td>
                <td className="bold align-text-right"></td>
              </tr>
            </tbody>
          </Table>
        </>
      ) : (
        <h5 className="text-center">{t("messages.noDataToDisplay")}</h5>
      )}
    </>
  );
}
